/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetRoleForManagementPageDocument = gql`
    query getRoleForManagementPage($branchId: Int!, $page: Int, $itemsPerPage: Int) {
  role(branchId: $branchId, page: $page, itemsPerPage: $itemsPerPage) {
    roles {
      id
      isDefault
      isOwner
      name
      description
      isDeleted
    }
    totalCount
    currentPage
    itemsPerPage
    pageCount
  }
}
    `;

/**
 * __useGetRoleForManagementPageQuery__
 *
 * To run a query within a React component, call `useGetRoleForManagementPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleForManagementPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleForManagementPageQuery({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *   },
 * });
 */
export function useGetRoleForManagementPageQuery(baseOptions: Apollo.QueryHookOptions<GetRoleForManagementPageQuery, GetRoleForManagementPageQueryVariables> & ({ variables: GetRoleForManagementPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleForManagementPageQuery, GetRoleForManagementPageQueryVariables>(GetRoleForManagementPageDocument, options);
      }
export function useGetRoleForManagementPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleForManagementPageQuery, GetRoleForManagementPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleForManagementPageQuery, GetRoleForManagementPageQueryVariables>(GetRoleForManagementPageDocument, options);
        }
export function useGetRoleForManagementPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleForManagementPageQuery, GetRoleForManagementPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoleForManagementPageQuery, GetRoleForManagementPageQueryVariables>(GetRoleForManagementPageDocument, options);
        }
export type GetRoleForManagementPageQueryHookResult = ReturnType<typeof useGetRoleForManagementPageQuery>;
export type GetRoleForManagementPageLazyQueryHookResult = ReturnType<typeof useGetRoleForManagementPageLazyQuery>;
export type GetRoleForManagementPageSuspenseQueryHookResult = ReturnType<typeof useGetRoleForManagementPageSuspenseQuery>;
export type GetRoleForManagementPageQueryResult = Apollo.QueryResult<GetRoleForManagementPageQuery, GetRoleForManagementPageQueryVariables>;
export const GetUsableRoleDocument = gql`
    query getUsableRole($branchId: Int!, $roleId: Int!) {
  usableRole(branchId: $branchId, roleId: $roleId)
}
    `;

/**
 * __useGetUsableRoleQuery__
 *
 * To run a query within a React component, call `useGetUsableRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsableRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsableRoleQuery({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useGetUsableRoleQuery(baseOptions: Apollo.QueryHookOptions<GetUsableRoleQuery, GetUsableRoleQueryVariables> & ({ variables: GetUsableRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsableRoleQuery, GetUsableRoleQueryVariables>(GetUsableRoleDocument, options);
      }
export function useGetUsableRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsableRoleQuery, GetUsableRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsableRoleQuery, GetUsableRoleQueryVariables>(GetUsableRoleDocument, options);
        }
export function useGetUsableRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsableRoleQuery, GetUsableRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsableRoleQuery, GetUsableRoleQueryVariables>(GetUsableRoleDocument, options);
        }
export type GetUsableRoleQueryHookResult = ReturnType<typeof useGetUsableRoleQuery>;
export type GetUsableRoleLazyQueryHookResult = ReturnType<typeof useGetUsableRoleLazyQuery>;
export type GetUsableRoleSuspenseQueryHookResult = ReturnType<typeof useGetUsableRoleSuspenseQuery>;
export type GetUsableRoleQueryResult = Apollo.QueryResult<GetUsableRoleQuery, GetUsableRoleQueryVariables>;
export const DeleteOrRestoreCustomRoleDocument = gql`
    mutation deleteOrRestoreCustomRole($companyId: Int!, $branchId: Int!, $roleId: Int!, $deleted: Boolean!) {
  deleteOrRestoreCustomRole(
    companyId: $companyId
    branchId: $branchId
    roleId: $roleId
    deleted: $deleted
  ) {
    isDeleted
  }
}
    `;
export type DeleteOrRestoreCustomRoleMutationFn = Apollo.MutationFunction<DeleteOrRestoreCustomRoleMutation, DeleteOrRestoreCustomRoleMutationVariables>;

/**
 * __useDeleteOrRestoreCustomRoleMutation__
 *
 * To run a mutation, you first call `useDeleteOrRestoreCustomRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrRestoreCustomRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrRestoreCustomRoleMutation, { data, loading, error }] = useDeleteOrRestoreCustomRoleMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      roleId: // value for 'roleId'
 *      deleted: // value for 'deleted'
 *   },
 * });
 */
export function useDeleteOrRestoreCustomRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrRestoreCustomRoleMutation, DeleteOrRestoreCustomRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrRestoreCustomRoleMutation, DeleteOrRestoreCustomRoleMutationVariables>(DeleteOrRestoreCustomRoleDocument, options);
      }
export type DeleteOrRestoreCustomRoleMutationHookResult = ReturnType<typeof useDeleteOrRestoreCustomRoleMutation>;
export type DeleteOrRestoreCustomRoleMutationResult = Apollo.MutationResult<DeleteOrRestoreCustomRoleMutation>;
export type DeleteOrRestoreCustomRoleMutationOptions = Apollo.BaseMutationOptions<DeleteOrRestoreCustomRoleMutation, DeleteOrRestoreCustomRoleMutationVariables>;
export type GetRoleForManagementPageQueryVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetRoleForManagementPageQuery = { __typename?: 'Query', role: { __typename?: 'RolePaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, roles?: Array<{ __typename?: 'RoleProxy', id: number, isDefault: boolean, isOwner: boolean, name: string, description: string, isDeleted: boolean }> | null } };

export type GetUsableRoleQueryVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  roleId: Types.Scalars['Int']['input'];
}>;


export type GetUsableRoleQuery = { __typename?: 'Query', usableRole: boolean };

export type DeleteOrRestoreCustomRoleMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  roleId: Types.Scalars['Int']['input'];
  deleted: Types.Scalars['Boolean']['input'];
}>;


export type DeleteOrRestoreCustomRoleMutation = { __typename?: 'Mutation', deleteOrRestoreCustomRole: { __typename?: 'RoleProxy', isDeleted: boolean } };
